var map = {
	"./add-attachment-to-mail.js": "oyQo",
	"./ai2.js": "wfud",
	"./all-atachments-upload.js": "Md0w",
	"./assets.js": "Zksc",
	"./client.js": "kE3P",
	"./data-protection.js": "xS3S",
	"./dm-explorer.js": "YG8c",
	"./document-excel.js": "1U57",
	"./document-image.js": "AbUM",
	"./document-pdf2.js": "kbt1",
	"./document-powerpoint.js": "fm+M",
	"./document-text.js": "XdTk",
	"./document-word.js": "LKRT",
	"./empty-icon.js": "8IUV",
	"./event-cancel.js": "IJDM",
	"./event-send.js": "udVC",
	"./file-cs.js": "XXiF",
	"./file-css.js": "Mibh",
	"./file-eaf.js": "Qn56",
	"./file-js.js": "+f1H",
	"./file-json.js": "8Fjj",
	"./file-mp4.js": "oeLf",
	"./file-ts.js": "BANp",
	"./file-webp.js": "0pXw",
	"./folder2-compressed.js": "FvkN",
	"./folder2.js": "DteR",
	"./form-project.js": "wugI",
	"./help-desk.js": "tws7",
	"./home.js": "Yh8a",
	"./human-resources.js": "Nq5I",
	"./indicators.js": "CIkm",
	"./login.js": "AIF9",
	"./logout.js": "2E9U",
	"./new-proj-file.js": "q6U8",
	"./other-app.js": "wHy6",
	"./recent-items.js": "2qpP",
	"./references.js": "KgL9",
	"./reporsitories2.js": "IgN8",
	"./reports.js": "jVU0",
	"./save-current-mail.js": "6UBP",
	"./server.js": "xiBp",
	"./settings.js": "9Rx0",
	"./shortcut.js": "yG/J",
	"./synergy.js": "7T3G",
	"./upload-selected.js": "ELDA",
	"./workflow-management.js": "hvyO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g9iI";